import React from 'react';

import Header from './components/Header';
import AboutMe from './components/AboutMe';
import Projects from './components/Projects';

import './App.css';

function App() {
  return (
    <>
      <Header />
      <AboutMe />
      <Projects />
    </>
  );
}

export default App;
